import * as React from "react"
import { CategoryType } from "@digits-graphql/frontend/graphql-bearer"
import { ResponsiveComponent } from "@digits-shared/components/Responsive/ResponsiveComponent"
import { AnalysisCategoryTypesContext } from "src/frontend/components/OS/Applications/Analysis/AnalysisCategoryTypesContext"
import { RevenueChrome } from "src/frontend/components/OS/Applications/Analysis/Revenue/RevenueChrome"
import { RevenueMobileChrome } from "src/frontend/components/OS/Applications/Analysis/Revenue/RevenueChrome.mobile"

/*
 COMPONENTS
*/

const RevenueApplication: React.FC = () => (
  <AnalysisCategoryTypesContext.Provider value={[CategoryType.Income, CategoryType.OtherIncome]}>
    <ResponsiveComponent desktop={RevenueChrome} mobile={RevenueMobileChrome} />
  </AnalysisCategoryTypesContext.Provider>
)

export default RevenueApplication
